import usePartyStore from "../../../stores/party.js";
import type { Party } from "../../../types.js";
import type { Socket } from "socket.io-client";

interface RosterProps {
	party: Party;
	socket: Socket;
}

function Roster(_props: RosterProps) {
	const party = usePartyStore.getState().party!;
	const players = Object.values(party.players);

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
			{players.map(player => (
				<div
					key={player.id}
					style={{
						display: "flex",
						alignItems: "center",
						gap: "var(--space-3)",
						padding: "var(--space-3) var(--space-4)",
						borderRadius: "var(--radius-md)",
						background: "var(--bg-surface)",
						border: "1px solid var(--border)",
					}}
				>
					{/* Color dot */}
					<div style={{
						width: 10,
						height: 10,
						borderRadius: "50%",
						background: player.color,
						flexShrink: 0,
						boxShadow: `0 0 6px ${player.color}88`,
					}} />

					{/* Name */}
					<span style={{
						flex: 1,
						fontWeight: 600,
						fontSize: "0.95rem",
						color: player.color,
					}}>
						{player.name}
					</span>

					{/* Host badge */}
					{player.isHost && (
						<span style={{
							fontSize: "0.68rem",
							fontWeight: 700,
							letterSpacing: "0.06em",
							textTransform: "uppercase",
							color: "var(--reward)",
							background: "var(--reward-muted)",
							border: "1px solid rgba(255,230,109,0.2)",
							borderRadius: "var(--radius-pill)",
							padding: "2px 8px",
						}}>
							Host
						</span>
					)}

					{/* Ready state */}
					{player.isReady ? (
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4ec9b7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
							<path d="M20 6L9 17l-5-5" />
						</svg>
					) : (
						<div style={{
							width: 18,
							height: 18,
							borderRadius: "50%",
							border: "2px solid var(--border-strong)",
						}} />
					)}
				</div>
			))}
		</div>
	);
}

export default Roster;
